import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '@env/environment';
import { Products } from '../models/product';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  apiURLProducts = environment.apiURL + 'products';
  constructor(private http: HttpClient) {}

  getProducts(categoriesFilter?: string[]): Observable<Products[]> {
    let params = new HttpParams();
    if (categoriesFilter) {
      params = params.append('categories', categoriesFilter.join(','));
    }
    return this.http.get<Products[]>(this.apiURLProducts, { params: params });
  }
  getProduct(productId: string): Observable<Products> {
    return this.http.get<Products>(`${this.apiURLProducts}/${productId}`);
  }

  createProduct(productData: FormData): Observable<Products> {
    return this.http.post<Products>(this.apiURLProducts, productData);
  }
  updateProducts(
    productData: FormData,
    productid: string
  ): Observable<Products> {
    return this.http.put<Products>(
      `${this.apiURLProducts}/${productid}`,
      productData
    );
  }

  deleteProduct(productId: string): Observable<any> {
    return this.http.delete<Products>(`${this.apiURLProducts}/${productId}`);
  }

  getProductsCount(): Observable<number> {
    return this.http
      .get<number>(`${this.apiURLProducts}/get/count`)
      .pipe(map((objectValue: any) => objectValue.productCount));
  }

  getFeaturedProducts(count: number): Observable<Products[]> {
    return this.http.get<Products[]>(
      `${this.apiURLProducts}/get/featured/${count}`
    );
  }
}
